module.exports = __webpack_public_path__ + "static/media/SelectLoan-Icon.a075efe5.svg";